const days = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

const getWeekDay = (date: Date) => days[date.getDay()];

export default getWeekDay;
